"use strict";

function throttle(func, wait) {
  var timeout = void 0;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!timeout) {
      timeout = setTimeout(function () {
        func.apply(undefined, args);
        timeout = null;
      }, wait);
    }
  };
}

module.exports = throttle;
//# sourceMappingURL=throttle.js.map